<div class="target" *ngIf="dotPosition" [ngStyle]="{'left': dotPosition.x + 'vw', 'bottom': 100 - dotPosition.y + 'vh'}"></div>
<div class="arrow" *ngIf="arrowAngle !== undefined" [ngStyle]="{'transform': 'translate(-50%) rotate('+ arrowAngle +'deg)'}">
  <img src="assets/images/arrow.svg">
</div>
